const VIDEO_SELECTOR = '.clv-band video[autoplay], .clv-hero video[autoplay], .clv-rstep video[autoplay]';
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const managedVideos = new Set();

const isInViewport = (element) => {
  const rect = element.getBoundingClientRect();

  return rect.bottom > 0 && rect.top < window.innerHeight;
};

const resetVideo = (video) => {
  const reset = () => {
    try {
      video.currentTime = 0;
    } catch {
      // A video can reject seeking until its metadata is ready.
    }
  };

  if (video.readyState >= HTMLMediaElement.HAVE_METADATA) {
    reset();
  } else {
    video.addEventListener('loadedmetadata', reset, { once: true });
  }
};

const shouldPlay = (video) => {
  const hero = video.closest('.clv-hero');

  return (
    !reducedMotion.matches &&
    !document.hidden &&
    video.dataset.clvInView === 'true' &&
    !hero?.classList.contains('clv-hero--paused')
  );
};

const syncVideo = (video) => {
  if (shouldPlay(video)) {
    video.play().catch(() => {});
    return;
  }

  video.pause();
  if (reducedMotion.matches) resetVideo(video);
};

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      entry.target.dataset.clvInView = String(entry.isIntersecting && entry.intersectionRatio >= 0.15);
      syncVideo(entry.target);
    });
  },
  { threshold: [0, 0.15, 0.5] }
);

const setupVideos = (root = document) => {
  root.querySelectorAll(VIDEO_SELECTOR).forEach((video) => {
    if (managedVideos.has(video)) return;

    managedVideos.add(video);
    video.dataset.clvInView = String(isInViewport(video));
    observer.observe(video);
    syncVideo(video);
  });
};

const setupHeroControls = (root = document) => {
  const labelsElement = document.querySelector('[data-clv-motion-labels]');
  const labels = labelsElement ? JSON.parse(labelsElement.textContent) : { pause: 'Pause', play: 'Play' };

  root.querySelectorAll('.clv-hero:not([data-clv-motion-ready])').forEach((hero) => {
    const button = document.createElement('button');
    const labelElement = document.createElement('span');

    hero.dataset.clvMotionReady = 'true';
    button.className = 'clv-hero__motion-toggle';
    button.type = 'button';
    button.hidden = reducedMotion.matches;
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('aria-label', labels.pause);
    labelElement.dataset.clvMotionLabel = '';
    labelElement.textContent = labels.pause;
    button.append(labelElement);
    hero.append(button);

    button.addEventListener('click', () => {
      const isPaused = button.getAttribute('aria-pressed') !== 'true';
      const label = isPaused ? labels.play : labels.pause;

      hero.classList.toggle('clv-hero--paused', isPaused);
      button.setAttribute('aria-pressed', String(isPaused));
      button.setAttribute('aria-label', label);
      labelElement.textContent = label;
      hero.querySelectorAll('video').forEach(syncVideo);
    });
  });
};

const setup = (root = document) => {
  setupVideos(root);
  setupHeroControls(root);
};

document.addEventListener('visibilitychange', () => managedVideos.forEach(syncVideo));
document.addEventListener('shopify:section:load', (event) => setup(event.target));
window.addEventListener('pageshow', () => setup());
reducedMotion.addEventListener('change', () => {
  document.querySelectorAll('.clv-hero__motion-toggle').forEach((button) => {
    button.hidden = reducedMotion.matches;
  });
  managedVideos.forEach(syncVideo);
});

setup();
